import React, { useRef } from 'react';
import clsx from 'clsx';
import { useMenuProductCategory } from '../../../hooks/menu-product-category';
import { useZone } from '../../../hooks/zone';
import { XButton } from '@orderx/lab/ui';
import './ZoneViewProductCategorySelect.scss';
import sum from 'lodash/sum';
import { useProductCategories } from '../../../hooks/useProductCategories';
import { startCase } from '../../../util/startCase';

export function ZoneViewProductCategorySelect() {
    const zone = useZone();
    const refCategories = useRef<any>();
    const refSubCategories = useRef<any>();

    const {
        category: activeCategory,
        setCategory,
        subCategory: activeSubCategory,
        setSubCategory,
    } = useMenuProductCategory();

    const { categories, subCategories } = useProductCategories({
        menuProducts: zone.menuProducts,
        activeCategory: activeCategory,
    });

    function getButton({ label, value, isActive, setValue }) {
        return (
            <XButton
                className={clsx({ isActive })}
                onClick={() => {
                    setValue(value);

                    const targetHeight = 210;

                    // TODO
                    if (window.pageYOffset > targetHeight) {
                        window.scrollTo(0, targetHeight);
                    }
                }}
                key={value}>
                {label}
            </XButton>
        );
    }

    function getScrollRightButton(element) {
        return (
            <XButton
                icon={'navigate_next'}
                variant={'filled'}
                className={'scroll-right'}
                onClick={() => {
                    element.scrollTo({
                        left: (element.scrollLeft || 0) + 200,
                        behavior: 'smooth',
                    });
                }}>
                <div className={'gradient'} />
            </XButton>
        );
    }

    function hasScroller(ref) {
        if (!ref?.current) {
            return false;
        }

        const bodyWidth = document.body?.getBoundingClientRect?.()?.width || 0;

        const scrollerWidth = sum(
            Array.from(ref.current.querySelectorAll('button')).map((item: any) => item.offsetWidth),
        );

        return bodyWidth < scrollerWidth;
    }

    return (
        <>
            <div className={clsx('ZoneViewProductCategorySelect')}>
                <div ref={refCategories} className="row">
                    {getButton({
                        label: 'All',
                        value: '',
                        isActive: activeCategory === '',
                        setValue: setCategory,
                    })}

                    {categories.map((category) =>
                        getButton({
                            label: startCase(category),
                            value: category,
                            isActive: activeCategory === category,
                            setValue: setCategory,
                        }),
                    )}
                </div>

                {hasScroller(refCategories) && getScrollRightButton(refCategories.current)}
            </div>

            {subCategories.length > 0 && (
                <div className={clsx('ZoneViewProductCategorySelect sub-categories sticky')}>
                    <div ref={refSubCategories} className="row">
                        {subCategories.map((subCategory) =>
                            getButton({
                                label: startCase(subCategory),
                                value: subCategory,
                                isActive: activeSubCategory === subCategory,
                                setValue: setSubCategory,
                            }),
                        )}
                    </div>

                    {hasScroller(refSubCategories) && getScrollRightButton(refSubCategories.current)}
                </div>
            )}
        </>
    );
}
